module.exports = __webpack_public_path__ + "img/banner4.4ec98786.png";